var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcChat(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M26.6641 12.0013C25.6038 6.68737 20.6811 2.66797 14.7698 2.66797C8.08472 2.66797 2.66406 7.80825 2.66406 14.148C2.66406 17.1941 3.91498 19.9618 5.95546 22.0157C6.40472 22.468 6.70466 23.0858 6.58361 23.7217C6.38382 24.7614 5.93108 25.7313 5.26813 26.5396C7.01237 26.8612 8.82602 26.5716 10.3814 25.7516C10.9312 25.4618 11.2062 25.3169 11.4002 25.2874C11.536 25.2669 11.7128 25.2861 11.9974 25.3349",
    stroke: "black",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.6641 21.6836C14.6641 25.5578 17.9478 28.6992 21.9974 28.6992C22.4735 28.6997 22.9483 28.6557 23.4161 28.568C23.7527 28.5046 23.9211 28.473 24.0386 28.491C24.1561 28.5089 24.3227 28.5976 24.6558 28.7746C25.5979 29.2757 26.6966 29.4526 27.7533 29.2561C27.3517 28.7622 27.0774 28.1696 26.9563 27.5341C26.883 27.1456 27.0647 26.768 27.3369 26.4916C28.573 25.2364 29.3307 23.545 29.3307 21.6836C29.3307 17.8093 26.047 14.668 21.9974 14.668C17.9478 14.668 14.6641 17.8093 14.6641 21.6836Z",
    stroke: "black",
    strokeWidth: 2,
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcChat);
export default __webpack_public_path__ + "static/media/ic-chat.fa935cf2994da24e30e455fa81c3f190.svg";
export { ForwardRef as ReactComponent };